module.exports = __webpack_public_path__ + "static/media/img011.9a567d75.jpg";